/**
 * "Referencia DMS" (AUTOSUR): optional, 8 to 10 characters once trimmed.
 *
 * The backend applies the same rule (SAAF_Back, src/server/schemas/assets_schemas.js,
 * plus trim_middleware). The pattern tolerates leading and trailing spaces and
 * counts only what is between them, so "1234567 " is 7 and fails; the value is
 * trimmed before it is sent (trimDmsReference).
 */
export const DMS_REFERENCE_MAX_LENGTH = 10;

export const DMS_REFERENCE_PATTERN = '^\\s*(\\S[\\s\\S]{6,8}\\S)?\\s*$';

/**
 * Copy of the asset with dmsReference trimmed. Same object when there is
 * nothing to trim.
 *
 * @param {Object} asset
 */
export const trimDmsReference = (asset) =>
  asset && typeof asset.dmsReference === 'string'
    ? { ...asset, dmsReference: asset.dmsReference.trim() }
    : asset;



// WEBPACK FOOTER //
// src/lib/assets/dms_reference.js